import { useTranslation } from "react-i18next";
import { capitalize, upperCase } from "../../../utils/manipulateText";
import { useSelector } from "react-redux";
import { useBusinessBreakdownAndFilters } from "../BusinessBreakdownAndFilters";
import Tooltip from "../../common/Tooltip";

function Breakdown() {
  const { t } = useTranslation();
  const selectedSite = useSelector((state) => state.site?.selectedSite);
  const { breakdowns, setBreakdowns } = useBusinessBreakdownAndFilters();

  const onBreakdownChange = (e) => {
    e.preventDefault();

    const bd =
      e.target.dataset.breakdown || e.target.parentNode.dataset.breakdown;

    setBreakdowns((breakdowns) => {
      const bdIndex = breakdowns.indexOf(bd);
      if (bdIndex === -1) {
        return [...breakdowns, bd];
      } else {
        return breakdowns.toSpliced(bdIndex, 1);
      }
    });
  };

  return (
    <div className="pt-2 w-full md:w-auto">
      <label className="leading-8 text-gray-600 font-semibold text-sm ml-1">
        {capitalize(t("breakdown"))}
      </label>
      <br />
      <Tooltip
        title="breakdown"
        content={"you can select multiple choices here."}
      >
        <div className="flex ">
          <span className="inline-flex p-1 border bg-gray-200 rounded-md mx-1 items-center justify-center">
            <button
              className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                breakdowns.indexOf("day") !== -1 ? "bg-white shadow" : ""
              }`}
              onClick={onBreakdownChange}
              data-breakdown="day"
            >
              <label className="cursor-pointer mr-1 float-left">
                {upperCase(t("dailyBreakdown"))}
              </label>
            </button>
            <button
              className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                breakdowns.indexOf("month") !== -1 ? "bg-white shadow" : ""
              }`}
              onClick={onBreakdownChange}
              data-breakdown="month"
            >
              <label className="cursor-pointer mr-1 float-left">
                {upperCase(t("monthlyBreakdown"))}
              </label>
            </button>
            {
              <button
                className={`cursor-pointer transition-all ease-out transition-fast text-xs font-bold px-3 py-1 rounded mx-1 my-1 md:my-0 ${
                  breakdowns.indexOf("site") !== -1 ? "bg-white shadow" : ""
                }`}
                onClick={onBreakdownChange}
                data-breakdown="site"
              >
                <label className="cursor-pointer mr-1 float-left">
                  {upperCase(t("site"))}
                </label>
              </button>
            }
          </span>
        </div>
      </Tooltip>
    </div>
  );
}

export default Breakdown;
